import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import Login from "./pages/Login/Login";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import DetailedInquiry from "./pages/DetailedInquiry/DetailedInquiry";
import DetailCustomer from "./pages/DetailCustomer/DetailCustomer";
import ManageDiscount from "./pages/ManageDiscount/ManageDiscount";
import ManageColors from "./pages/ManageColors/ManageColors";
import ManageCountry from "./pages/ManageCountry/ManageCountry";
import InventoryDetail from "./pages/DetailInventory/DetailedInventory";
import { ROUTES } from "./constants/constants";
import { Provider } from "react-redux";
import { store } from "./store/store";
import AuthWrapper from "./components/HOC/AuthWrapper";

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <AuthWrapper>
        <Routes>
          <Route path={ROUTES.HOME} element={<Home />} />
          <Route path={ROUTES.LOGIN} element={<Login />} />
          <Route path={ROUTES.RESET_PASSWORD} element={<ResetPassword />} />
          <Route path={ROUTES.MANAGE_COLORS} element={<ManageColors />} />
          <Route path={ROUTES.MANAGE_COUNTRY} element={<ManageCountry />} />
          <Route path={ROUTES.MANAGE_DISCOUNT} element={<ManageDiscount />} />
          <Route path={ROUTES.INQUIRY_DETAIL} element={<DetailedInquiry />} />
          <Route path={ROUTES.CUSTOMER_DETAIL} element={<DetailCustomer />} />
          <Route path={ROUTES.INVENTORY_DETAIL} element={<InventoryDetail />} />
        </Routes>
      </AuthWrapper>
    </Provider>
  );
};

export default App;
